import type { CapabilityContext, CapabilityKey } from "./capabilities";
import type { FeatureGate } from "./types";

const buildError = (capability: CapabilityKey) =>
  new Error(`Capability "${capability}" is not enabled in the current feature gate.`);

export const denyAllFeatureGate: FeatureGate = {
  has: () => false,
  assert(capability: CapabilityKey, _context?: CapabilityContext) {
    throw buildError(capability);
  },
};

export const allowAllFeatureGate: FeatureGate = {
  has: () => true,
  assert: () => {
    // No-op: capability is always available.
  },
};
